// src/utils/apiClient.js (или другое подходящее место)
import axios from 'axios';
import { auth } from '../firebaseConfig'; // Путь к твоей конфигурации Firebase
import { config } from '../config'; // Путь к твоей конфигурации API URL
import logger from './logger';
// Импортируй sessionStore, чтобы иметь возможность разлогинить пользователя при ошибке 401/403
import sessionStore from '../stores/sessionStore'; // Убедись, что нет циклической зависимости

// Флаг для определения инициализации приложения
let _isInitialLoad = true;
setTimeout(() => {
  _isInitialLoad = false;
}, 5000); // Даем 5 секунд на инициализацию

const apiClient = axios.create({
  baseURL: config.apiUrl, // Используй базовый URL из конфига
});

// Request interceptor
apiClient.interceptors.request.use(
  async (config) => {
    // Добавляем флаг для отслеживания загрузки при инициализации
    config._isInitialLoad = _isInitialLoad;
    
    // Не добавляем токен к публичным путям (например, /auth/verify)
    if (config.url === '/auth/verify') {
       return config;
    }

    const user = auth.currentUser; // Получаем ТЕКУЩЕГО пользователя Firebase

    if (user) {
      try {
        logger.log('Interceptor: Getting ID token for request:', config.url);
        const token = await user.getIdToken(); // Получаем АКТУАЛЬНЫЙ токен
        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
          logger.log('Interceptor: Token added to header for:', config.url);
        } else {
           logger.warn('Interceptor: Token was null for user:', user.uid);
        }
      } catch (error) {
        logger.error("Interceptor: Could not get ID token for request", error);
        // Не разлогиниваем во время инициализации
        if (!_isInitialLoad) {
          // Если токен получить не удалось (например, сессия истекла на стороне Firebase)
          // setTimeout(() => sessionStore.logout(), 0);
        }
      }
    } else {
       logger.log('Interceptor: No Firebase user found for request:', config.url);
       // Если пользователя нет, а запрос идет к защищенному эндпоинту,
       // бэкенд должен вернуть 401/403, что обработает response interceptor
    }
    return config;
  },
  (error) => {
    logger.error('Interceptor Request Error:', error)
    return Promise.reject(error);
  }
);

// Response interceptor (опционально, но полезно для обработки 401/403)
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    logger.error('Interceptor Response Error:', error.response?.status, error.config?.url, error.message);
    const originalRequest = error.config;

    // Если ошибка 401 (Unauthorized) или 403 (Forbidden)
    if (error.response && (error.response.status === 401 || error.response.status === 403) && !originalRequest._retry) {
       // Проверяем, что это не ошибка от самого /auth/verify, чтобы не зациклиться
       if (originalRequest.url !== '/auth/verify' && !originalRequest._isInitialLoad) {
          logger.warn(`Unauthorized (401) or Forbidden (403) request to ${originalRequest.url}. Logging out.`);
          // Автоматически разлогиниваем пользователя только если не первичная загрузка
          setTimeout(() => sessionStore.logout(), 0);
       } else if (originalRequest._isInitialLoad) {
          logger.warn(`Ignoring 401/403 during initial app load for ${originalRequest.url}`);
       }
    }
    // Возвращаем ошибку в любом случае
    return Promise.reject(error);
  }
);

export default apiClient;